var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow":"hidden","font-family":"'VzNHGeDS-reg11'"}},[_c('div',{attrs:{"id":"vz-gh20"}}),_c('div',[_c('VPSPwdLessLogin')],1),_c('div',{attrs:{"id":"vz-gf20"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }